/**
 * [pug template]
 */
<template lang="pug">
  .rail-field-widget
    div
      a.doc-link.scrollAnchor(href="#mecanisme", :target="_blank", v-text="frText.abTest.prd14.variationB.fields.railType.compareRailLink")
    div(v-for="adaptedRailType in adaptedRailTypes()")
      .rail-type-title()
        .rail-type-title-part
          span.title(v-text="adaptedRailType.opt.label")
          span.sub-title(v-if="adaptedRailType.subTitle", v-text="adaptedRailType.subTitle")
        .rail-type-title-part(v-text="adaptedRailType.priceIndicator")
        .rail-type-title-part(v-if="adaptedRailType.colorSumary")
          span.color-summary(v-if="adaptedRailType.colorSumary", v-text="adaptedRailType.colorSumary")
      div
        .color-picto-hexa-container(v-for="railColor in adaptedRailType.relatedColorOpt")
          label.color-picto-hexa(:class="{'selected': (selected === railColor.colorOptKey)}", v-bind:style="{ 'background-color': railColor.pictureColor, 'border-color': (selected === railColor.colorOptKey) ? null : railColor.pictureBorderColor }", :for="railColor.colorOptKey")
          input(type="radio", :id="railColor.colorOptKey", :name="'railFieldWidget'", :value="railColor.colorOptKey", v-model="selected")
</template>
/**
 * [javascript application]
 */
<script>
import fr from '../../../config/translationFr'
export default {
  name: 'rail-field-widget',
  props: {
    cc: {
      type: Object,
      default: () => ({
        config_1: {
          prefilled_values: {
            'CH-147_couleur-de-rail-classique': 'OPT-236_blanc-ral-9010'
          }
        }
      })
    },
    railTypeField: {
      type: Object,
      default: () => ({})
    },
    railColorField: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      selected: null
    }
  },
  created: function () {
    if (this.cc['CH-147_couleur-de-rail-classique'] != null) {
      this.selected = this.cc['CH-147_couleur-de-rail-classique']
    }
  },
  computed: {
    frText: () => fr
  },
  methods: {
    getRelatedRailTypeOptKey: function (railColorOptKey) {
      const adaptedRailType = this.adaptedRailTypes()
      return adaptedRailType.reduce((reduced, rail) => {
        const relatedColor = rail.relatedColorOpt.find(colorOpt => colorOpt.value === railColorOptKey)
        if (relatedColor) {
          reduced = rail.key
        }
        return reduced
      }, 'OPT-234_rail-classique')
    },
    adaptedRailTypes: function () {
      //
      const getColorLabel = () => {
        if (this.railColorField.values) {
          if (this.railColorField.values[this.selected]) {
            return this.railColorField.values[this.selected].label
          }
        }
        return false
      }

      let colorSelectedIsClassic = false
      const classicRailColor = []
      if (this.railColorField.values['OPT-236_blanc-ral-9010']) {
        classicRailColor.push(Object.assign({}, this.railColorField.values['OPT-236_blanc-ral-9010'], {
          colorOptKey: 'OPT-236_blanc-ral-9010',
          pictureColor: '#FFFFFF',
          pictureBorderColor: '#909090'
        }))
        colorSelectedIsClassic = colorSelectedIsClassic || this.selected === 'OPT-236_blanc-ral-9010'
      }
      if (this.railColorField.values['OPT-270_marron-ral-8014']) {
        classicRailColor.push(Object.assign({}, this.railColorField.values['OPT-270_marron-ral-8014'], {
          colorOptKey: 'OPT-270_marron-ral-8014',
          pictureColor: '#543c2b',
          pictureBorderColor: '#543c2b'
        }))
        colorSelectedIsClassic = colorSelectedIsClassic || this.selected === 'OPT-270_marron-ral-8014'
      }
      //
      const premiumRailColor = []
      if (this.railColorField.values['OPT-238_blanc-ral-9016']) {
        premiumRailColor.push(Object.assign({}, this.railColorField.values['OPT-238_blanc-ral-9016'], {
          colorOptKey: 'OPT-238_blanc-ral-9016',
          pictureColor: '#FFFFFF',
          pictureBorderColor: '#909090'
        }))
      }
      if (this.railColorField.values['OPT-240_marron-ral-8077']) {
        premiumRailColor.push(Object.assign({}, this.railColorField.values['OPT-240_marron-ral-8077'], {
          colorOptKey: 'OPT-240_marron-ral-8077',
          pictureColor: '#543c2b',
          pictureBorderColor: '#543c2b'
        }))
      }
      if (this.railColorField.values['OPT-242_noir-ral-9005']) {
        premiumRailColor.push(Object.assign({}, this.railColorField.values['OPT-242_noir-ral-9005'], {
          colorOptKey: 'OPT-242_noir-ral-9005',
          pictureColor: '#000000',
          pictureBorderColor: '#000000'
        }))
      }
      //
      const adaptedValues = Object.keys(this.railTypeField.values).reduce((reduced, railTypeKey) => {
        const railTypeOpt = this.railTypeField.values[railTypeKey]
        reduced.push({
          key: railTypeKey,
          colorSumary: ((!colorSelectedIsClassic && railTypeKey !== 'OPT-234_rail-classique') || (colorSelectedIsClassic && railTypeKey === 'OPT-234_rail-classique')) ? getColorLabel() : null,
          opt: railTypeOpt,
          subTitle: (railTypeKey === 'OPT-234_rail-classique') ? null : '(utilisation intensive)',
          priceIndicator: (railTypeKey === 'OPT-234_rail-classique') ? '€' : '€€',
          relatedColorOpt: (railTypeKey === 'OPT-234_rail-classique') ? classicRailColor : premiumRailColor
        })
        return reduced
      }, [])
      return adaptedValues
    }
  },
  watch: {
    selected: function (newValue, oldValue) {
      const relatedRailTypeOptKey = this.getRelatedRailTypeOptKey(newValue)
      this.$emit('change-rail-color-type', {
        [this.railTypeField.chKey]: relatedRailTypeOptKey,
        [this.railColorField.chKey]: newValue
      })
    },
    cc: function (newValue, oldValue) {
      if (typeof newValue.config_1.prefilled_values['CH-147_couleur-de-rail-classique'] !== 'undefined') {
        if (newValue.config_1.prefilled_values['CH-147_couleur-de-rail-classique'] !== this.selected) {
          this.selected = newValue.config_1.prefilled_values['CH-147_couleur-de-rail-classique']
        }
      }
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style lang="scss">
</style>



// WEBPACK FOOTER //
// RailFieldWidget.vue?3c660b58